import React from 'react';
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google';
import styles from './GoogleLogin.module.css';

// 이미지 자원
import companyName from '../img/homepage/companyName.png';
import homepageCenterCircle from '../img/homepage/homepageCenterCircle.png';
import homepageRightHalf from '../img/homepage/homepageRightHalf.png';
import googleLoginButton from '../img/googleLogin/googleLoginButton.png';
import leftBottomLetter from '../img/homepage/leftBottomLetter.svg';
import rightBottomLetter from '../img/homepage/rightBottomLetter.svg';

const clientId = '1042833014059-i8ofmirdra3nrcmau0t5o2c93eink50u.apps.googleusercontent.com';

function LoginPage({ onLogin }) {
    // 구글 로그인 핸들러
    const login = useGoogleLogin({
        onSuccess: tokenResponse => {
            const token = tokenResponse?.access_token?.toString();
            
            if (!token) {
                console.error("Access Token을 찾을 수 없습니다.");
                return;
            }

            const reqOption = {
                method: "post",
                headers: {
                    "content-type": "application/json"
                },
                credentials: "include", // 세션/쿠키 연동 유지
                body: JSON.stringify({ token })
            };

            // 기존 API 엔드포인트 및 데이터 형식 유지
            fetch("/api/setToken", reqOption)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP error! status: ${response.status}`);
                    }
                    return response.json();
                })
                .then(data => {
                    // 성공 시 부모 컴포넌트에 알림
                    onLogin(true);
                })
                .catch(err => {
                    console.error('[로그인 API 에러]:', err);
                });
        },
        onError: (error) => console.error('[구글 로그인 실패]:', error)
    });

    return (
        <div className={styles.background}>
            <div className={styles.gridRightLeft}>
                <div />
                <img src={homepageRightHalf} className={styles.homepageRightHalf} alt='homepageRightHalf'/>
            </div>
            <img src={homepageCenterCircle} className={styles.homepageCenterCircle} alt='homepageCenterCircle'/>
            <div className={styles.topLetter}>
                P i o n e e r&nbsp;&nbsp;&nbsp;o f&nbsp;&nbsp;&nbsp;T a r g e t&nbsp;&nbsp;&nbsp;D i s c o v e r y&nbsp;&nbsp;&nbsp;a n d&nbsp;&nbsp;&nbsp;3 D&nbsp;&nbsp;&nbsp;C u l t u r e&nbsp;&nbsp;&nbsp;S y s t e m
            </div>
            <img src={companyName} className={styles.companyName} alt='companyName'/>
            
            {/* 로그인 버튼 섹션 */}
            <button onClick={() => login()} className={styles.googleLoginButtonDiv}>
                <img src={googleLoginButton} className={styles.googleLoginButton} alt='googleLoginButton'/>
            </button>
            
            <img src={leftBottomLetter} className={styles.leftBottomLetter} alt='leftBottomLetter'/>
            <img src={rightBottomLetter} className={styles.rightBottomLetter} alt='rightBottomLetter'/>
        </div>
    );
}

function GoogleLogin(props) {
    return (
        <GoogleOAuthProvider clientId={clientId}>
            {/* 불필요한 div depth 제거 */}
            <LoginPage onLogin={props.onLogin} />
        </GoogleOAuthProvider>
    );
}

export default GoogleLogin;